import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
  {
    name: 'Jan',
    Earnings: 400,
  },
  {
    name: 'Feb',
    Earnings: 300,
  },
  {
    name: 'Mar',
    Earnings: 200,
  },
  {
    name: 'Apr',
    Earnings: 278,
  },
  {
    name: 'May',
    Earnings: 189,
  },
  {
    name: 'Jun',
    Earnings: 239,
  },
  {
    name: 'Jul',
    Earnings: 349,
  },
];

const EarningsGraph = () => {
  return (
    <div className="cards table_card">
      <div className="cards_header">
        <div className="left_s">
          <h2>Total Earnings</h2>
        </div>
        <div className="right_s">
          <p>
            <span>A day</span>
            <span>A week</span>
            <span>A month</span>
            <span>A year</span>
          </p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={data}
          margin={{
            top: 20,
            right: 5,
            left: 5,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="Earnings" stroke="#e71c57" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EarningsGraph;
